import { Button, style } from '@do/walrus';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars.scss';
import { ButtonImage, ButtonImageBg, ButtonProps } from './Common';

const CustomButton = styled(Button)`
  margin-top: ${style.vars.whitespace.regular};
  border: ${style.vars.borderWidth.thin} solid ${vars.grey6};
  border-radius: ${vars.border_radius_xlarge};
  color: ${vars.grey3};
`;

interface OauthButtonProps extends ButtonProps {
  iconSrc: string;
}

const OauthButton = ({
  text,
  onClick,
  disabled = false,
  iconSrc
}: OauthButtonProps): ReactElement => {
  return (
    <CustomButton
      fullWidth
      variation="secondary"
      onClick={onClick}
      disabled={disabled}
    >
      <ButtonImageBg>
        <ButtonImage src={iconSrc} />
      </ButtonImageBg>
      {text}
    </CustomButton>
  );
};

export default OauthButton;
